import { type ReactNode } from "react"
import { Box, Dialog, IconButton, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { faCircleXmark } from "@fortawesome/pro-thin-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import { SafeArea } from "../../../../../../shared/components/skeleton/SafeArea"

const useStyles = makeStyles()((theme) => ({
    modal: {
        zIndex: 1100,
    },
    layout: {
        display: "flex",
        flexDirection: "column",
        background: theme.palette.common.white,
        "& .MuiToolbar-root": {
            borderRadius: 0,
        },
    },
    header: {
        position: "sticky",
        top: 0,
        zIndex: 10,
        display: "flex",
        alignItems: "center",
        gap: ".5rem",
        minHeight: "4.625rem",
        padding: ".75rem .5rem",
        background: theme.palette.common.white,
        borderBottom: `1px solid ${theme.palette.tailwind.slate[400]}`,
    },
    closeIcon: {
        color: theme.palette.tailwind.slate[600],
        fontSize: "2rem",
    },
    title: {
        color: theme.palette.tailwind.slate[900],
        fontWeight: 700,
    },
}))

type UpcomingOrdersModalProps = Readonly<{
    open: boolean
    onClose: () => void
    title: string
    children: ReactNode
}>

export function UpcomingOrdersModal({ open, onClose, title, children }: UpcomingOrdersModalProps) {
    const { classes } = useStyles()

    return (
        <Dialog open={open} onClose={onClose} fullWidth fullScreen scroll="paper" className={classes.modal}>
            <SafeArea>
                <Box className={classes.layout}>
                    <Box className={classes.header}>
                        <IconButton onClick={onClose}>
                            <FontAwesomeIcon icon={faCircleXmark} className={classes.closeIcon} />
                        </IconButton>
                        <Typography variant="h6" className={classes.title}>
                            {title}
                        </Typography>
                    </Box>
                    {children}
                </Box>
            </SafeArea>
        </Dialog>
    )
}
